(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/news/assets/javascripts/models/news-list.js') >= 0) return;  svs.modules.push('/components/sport/news/assets/javascripts/models/news-list.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs.sport.news.models.NewsList = Backbone.Model.extend({
    defaults: function() {
      return {
        displayError: 'false',
        errorMessage: { message: 'Inga nyheter är tillgängliga' }
      };
    }
  });
})(Backbone, _, svs);

 })(window);